import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { Field, Fields, reduxForm, SubmissionError } from 'redux-form';

import UploadField from 'components/fields/UploadField';

import { createPatientMessage } from 'redux/modules/patientsMessages';

import NotificationsDialogMessageDocumentFields from './NotificationsDialogMessageDocumentFields';

const styles = () => ({
  root: {
    position: 'relative',
    width: '100%',
    margin: '0 10px 0 16px',
  },
  uploadFieldContainer: {
    position: 'absolute',
    zIndex: 1,
    right: -2,
    top: -2,
  },
});

function onSubmit(values, dispatch, props) {
  return new Promise((resolve, reject) => {
    dispatch(createPatientMessage({
      values: {
        'Patient ID': props['Record Number'],
        ...values,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const NotificationsDialogForm = ({
  handleSubmit,
  submit,
  classes,
  account,
}) => (
  <form
    className={classes.root}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <div className={classes.uploadFieldContainer}>
      <Field
        id="Document"
        name="Document"
        component={UploadField}
        label="Attach file"
        fullWidth
        variant="icon"
      />
    </div>
    <Fields
      id="Document Name"
      names={[
        'Message',
        'Document',
      ]}
      component={NotificationsDialogMessageDocumentFields}
      submit={submit}
      account={account}
    />
  </form>
);

NotificationsDialogForm.propTypes = {
  'Record Number': PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default reduxForm({
  onSubmit,
})(withStyles(styles)(NotificationsDialogForm));



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialogForm.js